import type { PriceChangeItems } from "@/graphql/codegen/graphql"

export const hasPriceChangeGroupsWithItems = (priceChangeItems: PriceChangeItems): boolean =>
  priceChangeItems.groups.some((group) => group.items.length > 0)

export const getPriceChangeGroupsCustomerIds = (priceChangeItems?: PriceChangeItems[]): string[] => {
  if (!priceChangeItems) return []

  return priceChangeItems.flatMap((item) =>
    item.groups.flatMap((group) =>
      group.items.map((priceItem) => priceItem?.customerId ?? null).filter((v) => v !== null)
    )
  )
}
